var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "tags-input form-control" },
    [
      _c("VueTagsInput", {
        attrs: {
          tags: _vm.tags,
          "autocomplete-items": _vm.options,
          "autocomplete-always-open": !!_vm.statictags.length && _vm.focused,
          "add-on-key": [13, 188],
          "save-on-key": [13, 188]
        },
        on: {
          "tags-changed": function(newTags) {
            return (_vm.tags = newTags)
          },
          focus: function($event) {
            _vm.focus(true)
          },
          blur: function($event) {
            _vm.focus(false)
          }
        },
        model: {
          value: _vm.search,
          callback: function($$v) {
            _vm.search = $$v
          },
          expression: "search"
        }
      }),
      _vm._v(" "),
      _vm.loading
        ? _c("Icon", { staticClass: "loading", attrs: { name: "refresh" } })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0367cd8a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0367cd8a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/helpers/mixins/form/Tags.vue
// module id = null
// module chunks = 